import { Injectable } from '@angular/core';
import { BlockUIService } from 'ng-block-ui';

@Injectable({
    providedIn: 'root'
})
export class TfBlockUIService {

    constructor(
        private blockUI: BlockUIService
    ) {
    }

    start() {
        this.blockUI.start('main');
    }

    stop() {
        this.blockUI.stop('main');
    }
}
